



















































import { Observer } from 'mobx-vue'
import { Component, Inject, Vue } from 'vue-property-decorator'
import { SbStakingViewModel } from '../viewmodel/sb-staking-viewmodel'

@Observer
@Component
export default class STEHavestDialog extends Vue {
  @Inject() vm!: SbStakingViewModel
}
